<template>

  <b-modal 
    size="xl"
    v-model="isVisible"
    hide-footer
    @hidden="onHidden"
    title="Registrar una persona"
  >
    <div>
      <b-card class="mt-2">

        <b-row>
          <b-col md="6">
            <label>Tipo de Identificación: <span class="text-danger">*</span></label>
            <v-select
              v-model="persona.tipoIdentificacion"
              :options="optsTipoIdent"
              label="text"
              :class="{'input-error': errors.tipoIdent}"
              required
            />
            <small class="text-danger">{{errors.tipoIdentificacion}}</small>
          </b-col>


          <b-col md="6">
            <label>Identificación: <span class="text-danger">*</span></label>
            <b-form-input
              v-model="persona.identificacion"
              :class="{'input-error': errors.identificacion}"
              @keypress="onlyNumbers"             
              required
              :maxlength="maxLengthIdentificacion"
            />
            <small class="text-danger">{{errors.identificacion}}</small>
          </b-col>
        </b-row>


        <b-row class="mt-1" v-if="esIdentificacionValida">

          <b-col md="6">
            <label>Apellidos: <span class="text-danger">*</span></label>
            <b-form-input
              v-model="persona.apellidos"
              :class="{'input-error': errors.apellidos}"
              required
            />
            <small class="text-danger">{{errors.apellidos}}</small>

          </b-col>

          <b-col md="6">
            <label>Nombres: <span class="text-danger">*</span></label>
            <b-form-input
              v-model="persona.nombres"
              :class="{'input-error': errors.nombres}"
              required
            />
            <small class="text-danger">{{errors.nombres}}</small>
          </b-col>

          <b-col md="4" class="mt-1">
            <label>Fecha de Nacimiento: 
              <span class="text-danger" v-if="fechaNacimiento">*</span>
            </label>
            <flat-pickr
              class="form-control"
              v-model="persona.fechaNacimiento" 
              locale="es"
              :config="flatpickrConfig"
            />
            <small class="text-danger">{{errors.fechaNacimiento}}</small>
          </b-col>

          <b-col md="4" class="mt-1">
            <label>Nacionalidad: 
              <span class="text-danger" v-if="nacionalidad">*</span>
            </label>
            <v-select 
              v-model="persona.nacionalidad" 
              :options="optsNacionalidades" 
              label="text" 
            />
            <small class="text-danger">{{errors.nacionalidad}}</small>
          </b-col>

          <b-col md="4" class="mt-1">
            <label>Sexo: 
              <span class="text-danger" v-if="sexo">*</span>
            </label>
            <v-select 
              v-model="persona.sexo" 
              :options="optsSexo" 
              label="text" 
            />
            <small class="text-danger">{{errors.sexo}}</small>
          </b-col>
          
          <b-col md="6" class="mt-1">
            <label>Telefonos: 
              <span class="text-danger" v-if="telefonos">*</span>
            </label>
            <b-form-tags
              v-model="persona.celular"
              :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
              :tag-validator="tagValidator"
              separator=" "
              input-type="number"
              placeholder="099999999"
              :class="{'input-error': errors.celular}"
              required
            />
            <small class="text-danger">{{errors.celular}}</small>
          </b-col>

          <!-- <b-col md="6">
            <label>Correo: <span class="text-danger">*</span></label>
            <b-form-input
              v-model="persona.email"
              :class="{'input-error': errors.email}"
              required
            />
            <small class="text-danger">{{errors.email}}</small>
          </b-col> -->

        </b-row>
        

        <b-alert
          v-if="existeCedula" 
          variant="danger" 
          show
          class="text-center col-12 mt-2"
          style="padding: 40px; font-size: 20px;"
        >
          <i class="fa-solid fa-triangle-exclamation"/>
          Ya existe una cedula registrada con ese numero
          <div class="mt-1 d-flex justify-content-center">
            <h5 class="text-white mt-1">{{ personaExistente }}</h5>
            <b-button class="ml-2" size="sm" variant="info">
              <i class="fa-solid fa-eye"/>
            </b-button>
          </div>
        </b-alert>

        <b-row class="mt-4">
          <div class="col-12 d-flex justify-content-end">
            <b-button 
              :disabled="existeCedula"
              variant="success" 
              @click="onCrearPersona()"
            >
              Registrar persona
            </b-button>
          </div>
        </b-row>

      </b-card>
    </div>

    

  </b-modal>

  
</template>
  
<script>
  
import { BootstrapVue } from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';

import 'flatpickr/dist/flatpickr.css';
import { personasService, infoPersonasService } from '@/views/admision/services';
import { fileService } from '@/shared/services';
import { onlyNumbers } from '@/shared/helpers';
  
export default {
  name : "ModalCrearPersona",

  props: {
    fechaNacimiento : {
      type : Boolean,
      default : false
    },

    nacionalidad: {
      type : Boolean,
      default : false
    },

    sexo: {
      type : Boolean,
      default : false
    },

    telefonos: {
      type : Boolean,
      default : false
    }
  },
  
  components: {
    ...BootstrapVue.components,
    vSelect,
    flatPickr
  },

  created(){
    this.onValidateQueryParams();
    this.loadDataInit();
  },
  

  data() {
      
    return {
      
      onlyNumbers,
      isVisible : false,
      esIdentificacionValida : false,
      existeCedula : false,
      personaExistente : null,
      validForm : false,
      hizoUnSubmit : false,

      persona:{
        tipoIdentificacion : { value: '1', text: 'Cedula' },
        identificacion     : null,
        apellidos          : null,
        nombres            : null,
        fechaNacimiento    : null,
        nacionalidad       : null,
        celular            : null,
        email              : null
      },

      residencia:{},

      optsNacionalidades: [],

      optsTipoIdent: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Passporte' }
      ], 
      
      optsSexo: [
        { value: '0', text: 'Masculino' },
        { value: '1', text: 'Femenino' }
      ],


      // nombres : null,
      // apellidos : null,
      // tipoIdent : { value: '1', text: 'Cedula' },
      // identificacion : null,
      // celular : [],
      // email : null,
      // fechaNacimiento : null,

      errors: {
        tipoIdentificacion : null,
        identificacion     : null,
        apellidos          : null,
        nombres            : null,
        celular            : null,
        email              : null,
      },

      flatpickrConfig: {
        allowInput: true, // Muestra un campo de entrada de texto adicional
        minDate:'1900-01-01',
        maxDate:new Date(),
        static: true
      },
    }
  },


  methods : {

    async loadDataInit() {
      this.optsNacionalidades   = await infoPersonasService.getNacionalidades();
    },

    async onSearchPersona(query) {
      const searchPersona = await personasService.searchByQuery(query);


      if(!searchPersona) {
        this.esIdentificacionValida = true;
        this.existeCedula = false; 
        return;
      }

      const filterByTipoIdentificacion = searchPersona.filter( p => p.tipoIdentificacion === parseInt(this.persona.tipoIdentificacion.value));
      
      if(!filterByTipoIdentificacion.length ) {
        this.personaExistente = null;
        this.existeCedula = false;
        return;
      }

      const dataPersona = filterByTipoIdentificacion[0];
      this.personaExistente = `${dataPersona.identificacion} - ${dataPersona.primerApellido} ${dataPersona.primerNombre}`;

      this.esIdentificacionValida = false;
      this.existeCedula = true;

    },

    onValidateQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.isVisible = urlParams.get("new_person") === "true";
    },

    onHidden() {
      this.isVisible = false;
    },


    // validarCampos() {
    //   let isValid = true;

    //   // Resetear errores
    //   this.errors = {
    //     nombres        : false,
    //     apellidos      : false,
    //     tipoIdent      : false,
    //     identificacion : false,
    //     celular        : false,
    //     email          : false,
    //   };

    //   // Validar cada campo
    //   if (!this.nombres) {
    //     this.errors.nombres = true;
    //     isValid = false;
    //   }
    //   if (!this.apellidos) {
    //     this.errors.apellidos = true;
    //     isValid = false;
    //   }
    //   if (!this.tipoIdent) {
    //     this.errors.tipoIdent = true;
    //     isValid = false;
    //   }

    //   if (!this.identificacion || this.identificacion.length < 10 || this.identificacionrepetida ) {
    //     this.errors.identificacion = true;
    //     isValid = false;
    //   }

    //   if (!this.celular.length) {
    //     this.errors.celular = true;
    //     isValid = false;
    //   }
    //   if (!this.email) {
    //     this.errors.email = true;
    //     isValid = false;
    //   }

    //   if (!isValid ) {
    //     const identRepetida = `Ingrese una identificacion que no exista`;
    //     const mensaje = 'Por favor, complete todos los campos obligatorios.';
    //     this.$swal.fire({
    //       icon: 'error',
    //       title: 'Error',
    //       text: this.identificacionrepetida ? identRepetida : mensaje
    //     });
    //   }
    //   return isValid;
    // },

    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },

    async onCrearPersona() {

      this.hizoUnSubmit = true;

      this.validateForm();

      if(!this.validForm) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'No se puede crear la persona hay errores en la informacion ingresada.'
        })
        return;
      }


      let urlCedulaPersonaPaciente = null;

      if(this.persona.cedulaFile){
        urlCedulaPersonaPaciente =  await fileService.upload('cedulas', this.persona.cedulaFile, this.paciente.identificacion);
      }

      const dataNewPersona = {
        tipoIdentificacion : this.persona.tipoIdentificacion?.value,
        identificacion     : this.persona.identificacion,
        apellidos          : this.persona.apellidos,
        nombres            : this.persona.nombres,
        fechaNacimiento    : this.persona.fechaNacimiento,
        nacionalidad       : this.persona.nacionalidad?.value,
        sexo               : this.persona.sexo?.value,
        telefono           : this.persona.celular?.join(),

        estadoCivil        : this.persona.estadoCivil?.value,
        email              : this.persona.email,
        nivelEducacion     : this.persona.nivelEducacion?.value,
        profesion          : this.persona.profesion?.value,
        puebloKichwa       : this.persona.puebloKichwa?.value,
        nacionalidadEtnica : this.persona.nacionalidadEtnica?.value,

        esDiscapacitado    : this.persona.esDiscapacitado ? 1 : 0,

        urlIdentificacion  : urlCedulaPersonaPaciente,

        // pais               : this.residencia.pais?.value,
        // canton             : this.residencia.canton?.value,
        // parroquia          : this.residencia.parroquia,
        // barrio             : this.residencia.barrio,
        callePrincipal     : this.residencia.callePrincipal || 'Sin definir', 
        // calleSecundaria    : this.residencia.calleSecundaria,
        // referencia         : this.residencia.referencia
      }

      const personaCreada = await personasService.addPersona( dataNewPersona );

      if(!personaCreada){
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo crear la persona'
        });

        return;
      }

      this.$swal({
        icon: 'success',
        title: 'Persona Creada',
        text: 'Persona Creada Correctamente'
      });

      this.persona = {
        tipoIdentificacion : { value: '1', text: 'Cedula' },
        identificacion     : null,
        apellidos          : null,
        nombres            : null,
        fechaNacimiento    : null,
        nacionalidad       : null,
        celular            : null,
        email              : null
      };

      this.esIdentificacionValida = false
      this.existeCedula = false

      this.onHidden();
    },

    validateForm(){
      const persona = this.persona;

      this.errors.tipoIdentificacion = (!persona.tipoIdentificacion) 
        ? "El campo es obligatorio" : null;

      this.errors.identificacion = (!persona.identificacion) 
        ? "El campo es obligatorio" : null;
      
      this.errors.apellidos = (!persona.apellidos)
        ? "El campo es obligatorio" : null;

      this.errors.nombres = (!persona.nombres)
        ? "El campo es obligatorio" : null;

      if(this.fechaNacimiento)
        this.errors.fechaNacimiento = (!persona.fechaNacimiento)
          ? "El campo es obligatorio" : null;

      if(this.nacionalidad)
        this.errors.nacionalidad = (!persona.nacionalidad)
          ? "El campo es obligatorio" : null;

      if(this.sexo)
        this.errors.sexo = (!persona.sexo)
          ? "El campo es obligatorio" : null;

      if(this.telefonos)
        this.errors.celular = (!persona.celular || persona.celular.length === 0)
          ? "El campo es obligatorio" : null;

      const hayErrores = Object.values(this.errors).some(value => value !== null);

      this.validForm = !hayErrores;
    },

  },


  computed: {
    maxLengthIdentificacion() {
      const tipoIdentificacion = this.persona.tipoIdentificacion?.value;
      if (tipoIdentificacion === '0') return 13;
      if (tipoIdentificacion === '1') return 10;
      return 50;
    }
  },

  watch: {

    persona: {
      deep: true,
      handler() {
        if(this.hizoUnSubmit) this.validateForm()
      }
    },


    'persona.identificacion'(newValue) {

      if(!newValue) {
        this.esIdentificacionValida = false;
        this.existeCedula = false;
        return;
      }
      
      this.persona.identificacion = newValue.replace(/[^0-9]/g, '');


      if(this.persona.tipoIdentificacion.value === '0'){
        if(this.persona.identificacion.length < 13 || !this.persona.identificacion.length){ 
          this.esIdentificacionValida = false;
          this.existeCedula = false;
          return;
        }
      }

      if(this.persona.tipoIdentificacion.value === '1'){
        if(this.persona.identificacion.length < 10 || !this.persona.identificacion.length){ 
          this.esIdentificacionValida = false;
          this.existeCedula = false;
          return;
        }
      }

      if(this.persona.tipoIdentificacion.value === '2'){
        if(this.persona.identificacion.length < 3 || !this.persona.identificacion.length){ 
          this.esIdentificacionValida = false;
          this.existeCedula = false;
          return;
        }
      }

      this.onSearchPersona(newValue);
    },

    'persona.apellidos'(newValue){
      if(!newValue) return;
      this.persona.apellidos = newValue.toUpperCase();
    },

    'persona.nombres'(newValue){
      if(!newValue) return;
      this.persona.nombres = newValue.toUpperCase();
    },

    identificacion(newVal) {
      if (newVal.length > 9) {
        if(this.identificaciones.includes(newVal)){
          this.$toast.error("La identificacion ya fue ingresada anteriormente!");
          this.identificacionrepetida = true
        }else{
          this.$toast.success("Identificacion correcta");
          this.identificacionrepetida = false
        }
      }
    },

    '$route.query.new_person': {
      handler(newValue){
        if(!newValue) return;

        this.isVisible = true;
      },
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if( !newValue ) this.$router.push({ path: this.$route.path, query: {} })
      }
    }
  }

}
    
  
</script>

<style>
  .input-error {
    border-color: red !important;
  }

  .flatpickr-wrapper{
    width: 100%;
  }
</style>
  